export const namespace = 'checkedOrders'
